import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { GlobalSettingsService } from 'src/app/_Common/_Services/global-settings.service';
import { UserService } from 'src/app/_Common/_Services/user.service';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CallingService {
  constructor(private apiService: GlobalSettingsService, private userService: UserService, private http: HttpClient) {}

  getApiBaseUrl(): string {
    return this.apiService.getApiUrl();
  }

  // to start progressive calling
  startCalling(postObj): Observable<any> {
    return this.http
      .post(this.apiService.getApiUrl() + '/api/viewData/startProgressiveCall', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  // to resume the progressive call
  resumeCall(): Observable<any> {
    return this.http
      .get(this.apiService.getApiUrl() + '/api/viewData/resumeProgressiveFlow')
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  // to pause the progressive call
  pauseCall(): Observable<any> {
    return this.http
      .get(this.apiService.getApiUrl() + '/api/viewData/pauseProgressiveFlow')
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  // to stop the progressive call
  stopCall(): Observable<any> {
    return this.http
      .get(this.apiService.getApiUrl() + '/api/viewData/stopProgressiveFlow')
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  // to hold the Cube call
  holdCubeCall(): Observable<any> {
    return this.http
      .get(this.apiService.getApiUrl() + '/api/callService/holdCall')
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  // to unhold the Cube call
  unholdCubeCall(): Observable<any> {
    return this.http
      .get(this.apiService.getApiUrl() + '/api/callService/unholdCall')
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  // to resume the Cube call
  resumeCubeCall(): Observable<any> {
    return this.http
      .get(this.apiService.getApiUrl() + '/api/callService/removeBreak')
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }
  
  // to pause the Cube call
  pauseCubeCall(params): Observable<any> {
    return this.http
      .get(this.apiService.getApiUrl() + '/api/callService/addBreak',{params:{...params}})
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }
  
  // to stop the Cube call
  stopCubeCall(): Observable<any> {
    return this.http
      .get(this.apiService.getApiUrl() + '/api/viewData/stopProgressiveFlow')
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }
  
  // to start manual mode
  startManualMode(): Observable<any> {
    return this.http
      .get(this.apiService.getApiUrl() + '/api/callService/startManualMode')
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }
  
  // to stop manual mode
  stopManualMode(): Observable<any> {
    return this.http
      .get(this.apiService.getApiUrl() + '/api/callService/stopManualMode')
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  // to fetch Agent Ids
  getAgentIds(): Observable<any> {
    return this.http
      .get(this.apiService.getApiUrl() + '/api/callService/listAgentIds')
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  // to transfer call
  transferCall(postObj): Observable<any> {
    return this.http
      .post(this.apiService.getApiUrl() + '/api/callService/transferCall', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  // to conference call
  conferenceCall(postObj): Observable<any> {
    return this.http
      .post(this.apiService.getApiUrl() + '/api/callService/conferenceCall', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  // to merge call
  mergeCall(postObj): Observable<any> {
    return this.http
      .post(this.apiService.getApiUrl() + '/api/callService/mergeCall', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  // to unmerge call
  unMergeCall(): Observable<any> {
    return this.http
      .get(this.apiService.getApiUrl() + '/api/callService/unMergeCall')
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  autoDisposeCall(postObj): Observable<any> {
    return this.http
      .post(this.apiService.getApiUrl() + '/api/communicationManager/autoDisposeCall', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  dropCubeCall(): Observable<any> {
    return this.http
      .post(this.apiService.getApiUrl() + '/api/callService/dropCall', {})
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  manualOutboundCubeCall(postObj): Observable<any> {
    return this.http
      .post(this.apiService.getApiUrl() + '/api/callService/manualOutboundCall', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  completeCubeConference(postObj): Observable<any> {
    return this.http
      .post(this.apiService.getApiUrl() + '/api/callService/completeConference', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  fetchCubeCallLogs(postObj): Observable<any> {
    return this.http
      .post(this.apiService.getApiUrl() + '/api/callService/fetchCallLogs', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getCubeAgentStatus(): Observable<any> {
    return this.http
      .get(this.apiService.getApiUrl() + '/api/callService/getAgentStatus')
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  disposeCubeCallRaphsody(postObj): Observable<any> {
    return this.http
      .post(this.apiService.getApiUrl() + '/api/callService/disposeCallRaphsody', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  generateCubeApiToken(): Observable<any> {
    return this.http
      .post(this.apiService.getApiUrl() + '/api/callService/generateApiToken', {})
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  syncCubeSession(postObj: { authId: string; session?: Record<string, unknown> }): Observable<any> {
    return this.http
      .post(this.apiService.getApiUrl() + '/api/cube/sync-session', postObj)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getCubeSessionStatus(): Observable<any> {
    return this.http
      .get(this.apiService.getApiUrl() + '/api/cube/session-status')
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  bootstrapCubeConnectorSession(): Observable<any> {
    return this.http
      .post(this.apiService.getApiUrl() + '/api/cube/bootstrap-connector-session', {})
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  resumeCubeCampaignDial(campaignId?: string): Observable<any> {
    return this.http
      .post(this.apiService.getApiUrl() + '/api/cube/resume-campaign-dial', {
        campaignId: campaignId || '',
      })
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

  getCubeCampaignAgents(campaignId?: string, options?: { mode?: string }): Observable<any> {
    const params = new URLSearchParams();
    if (campaignId) {
      params.set('campaignId', campaignId);
    }
    if (options?.mode) {
      params.set('mode', options.mode);
    }
    const qs = params.toString() ? `?${params.toString()}` : '';
    return this.http
      .get(this.apiService.getApiUrl() + '/api/cube/campaign-agents' + qs)
      .pipe(catchError((e: any) => this.userService.getCheckError(e)));
  }

    holdOzonetelCall(): Observable<any> {
      return this.http
        .get(this.apiService.getApiUrl() + '/api/callService/holdCall')
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    unholdOzonetelCall(): Observable<any> {
      return this.http
        .get(this.apiService.getApiUrl() + '/api/callService/unholdCall')
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    resumeOzonetelCall(): Observable<any> {
      return this.http
        .get(this.apiService.getApiUrl() + '/api/callService/removeBreak')
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }
    
    pauseOzonetelCall(params): Observable<any> {
      return this.http
        .get(this.apiService.getApiUrl() + '/api/callService/addBreak',{params:{...params}})
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }
    
    stopOzonetelCall(): Observable<any> {
      return this.http
        .get(this.apiService.getApiUrl() + '/api/viewData/stopProgressiveFlow')
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }
    
    startOzonetelManualMode(): Observable<any> {
      return this.http
        .get(this.apiService.getApiUrl() + '/api/callService/startManualMode')
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }
    
    stopOzonetelManualMode(): Observable<any> {
      return this.http
        .get(this.apiService.getApiUrl() + '/api/callService/stopManualMode')
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    transferOzonetelCall(postObj): Observable<any> {
      return this.http
        .post(this.apiService.getApiUrl() + '/api/callService/transferCall', postObj)
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    conferenceOzonetelCall(postObj): Observable<any> {
      return this.http
        .post(this.apiService.getApiUrl() + '/api/callService/conferenceCall', postObj)
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    mergeOzonetelCall(postObj): Observable<any> {
      return this.http
        .post(this.apiService.getApiUrl() + '/api/callService/mergeCall', postObj)
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    unMergeOzonetelCall(): Observable<any> {
      return this.http
        .get(this.apiService.getApiUrl() + '/api/callService/unMergeCall')
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    autoDisposeOzonetelCall(postObj): Observable<any> {
      return this.http
        .post(this.apiService.getApiUrl() + '/api/communicationManager/autoDisposeCall',postObj)
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    muteOzonetelCall(): Observable<any> {
      return this.http
        .post(this.apiService.getApiUrl() + '/api/ozonetel/call/mute', {})
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    unmuteOzonetelCall(): Observable<any> {
      return this.http
        .post(this.apiService.getApiUrl() + '/api/ozonetel/call/unmute', {})
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    hangupOzonetelCall(): Observable<any> {
      return this.http
        .post(this.apiService.getApiUrl() + '/api/ozonetel/call/hangup', {})
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    sendOzonetelDTMF(digit: string): Observable<any> {
      return this.http
        .post(this.apiService.getApiUrl() + '/api/ozonetel/call/dtmf', { digit })
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    getOzonetelCampaigns(): Observable<any> {
      return this.http
        .get(this.apiService.getApiUrl() + '/api/ozonetel/campaigns')
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    getOzonetelOnlineAgents(): Observable<any> {
      return this.http
        .get(this.apiService.getApiUrl() + '/api/ozonetel/agents/online')
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    initOzonetelManualCall(params: { campId: string, phoneNumber: string, uui?: string }): Observable<any> {
      return this.http
        .post(this.apiService.getApiUrl() + '/api/ozonetel/call/manual', params)
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    loginOzonetelAgent(config: any): Observable<any> {
      return this.http
        .post(this.apiService.getApiUrl() + '/api/ozonetel/agent/login', config)
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    logoutOzonetelAgent(): Observable<any> {
      return this.http
        .post(this.apiService.getApiUrl() + '/api/ozonetel/agent/logout', {})
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    setOzonetelAgentMode(mode: string, status: string): Observable<any> {
      return this.http
        .post(this.apiService.getApiUrl() + '/api/ozonetel/agent/mode', { mode, status })
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    setOzonetelAgentStatus(status: string): Observable<any> {
      return this.http
        .post(this.apiService.getApiUrl() + '/api/ozonetel/agent/status', { status })
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    getOzonetelAgentStatus(): Observable<any> {
      return this.http
        .get(this.apiService.getApiUrl() + '/api/ozonetel/agent/status')
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    getCentroAgentConfig(): Observable<any> {
      return this.http
        .get(this.apiService.getApiUrl() + '/api/centro/agent-config')
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    loginCentroAgent(): Observable<any> {
      return this.http
        .post(this.apiService.getApiUrl() + '/api/centro/agent/login', {})
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    reloginCentroAgent(): Observable<any> {
      return this.http
        .post(this.apiService.getApiUrl() + '/api/centro/agent/relogin', {})
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    activateCentroAgent(postObj: { browserControlWs?: boolean }): Observable<any> {
      return this.http
        .post(this.apiService.getApiUrl() + '/api/centro/agent/activate', postObj || {})
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    getCentroSipStatus(
      browserSipRegistered = false,
      browserSipInCall = false,
      browserSipRinging = false
    ): Observable<any> {
      const params = new URLSearchParams({
        browserSip: browserSipRegistered ? 'true' : 'false',
        browserSipInCall: browserSipInCall ? 'true' : 'false',
        browserSipRinging: browserSipRinging ? 'true' : 'false',
      });
      return this.http
        .get(this.apiService.getApiUrl() + `/api/centro/agent/sip-status?${params.toString()}`)
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    getCentroControlStatus(browserSipInCall = false, browserSipRinging = false): Observable<any> {
      const params = new URLSearchParams({
        browserSipInCall: browserSipInCall ? 'true' : 'false',
        browserSipRinging: browserSipRinging ? 'true' : 'false',
      });
      return this.http
        .get(this.apiService.getApiUrl() + `/api/centro/agent/control-status?${params.toString()}`)
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    postCentroLineEvent(event: string | Record<string, unknown>): Observable<any> {
      const body = typeof event === 'string'
        ? { status: event }
        : { ...(event || {}) };
      return this.http
        .post(this.apiService.getApiUrl() + '/api/centro/agent/line-event', body)
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    postCentroSipSync(browserSipInCall = false, browserSipRinging = false, refresh = false): Observable<any> {
      return this.http
        .post(this.apiService.getApiUrl() + '/api/centro/agent/sip-sync', {
          inCall: browserSipInCall,
          ringing: browserSipRinging,
          refresh
        })
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    getCentroAgentStatus(): Observable<any> {
      return this.http
        .get(this.apiService.getApiUrl() + '/api/centro/agent/status')
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    logoutCentroAgent(): Observable<any> {
      return this.http
        .post(this.apiService.getApiUrl() + '/api/centro/agent/logout', {})
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    centroFreeAgent(userStatusId?: string): Observable<any> {
      const body = userStatusId ? { id: userStatusId } : {};
      return this.http
        .post(this.apiService.getApiUrl() + '/api/centro/agent/free-agent', body)
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    centroManualCall(postObj: { phoneNo: string }): Observable<any> {
      return this.http
        .post(this.apiService.getApiUrl() + '/api/centro/call/manual', postObj)
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    centroHangupCall(body: { skipAutoDispose?: boolean } = {}): Observable<any> {
      return this.http
        .post(this.apiService.getApiUrl() + '/api/centro/call/hangup', body)
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    centroDisposeCall(body: {
      disposition: string;
      remarks?: string;
      subDisposition?: string;
      recordId?: string;
      crmDataId?: string;
      crmLeadId?: string;
      phoneNo?: string;
      callType?: string;
    }): Observable<any> {
      return this.http
        .post(this.apiService.getApiUrl() + '/api/centro/call/dispose', body)
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    centroGetCallContext(): Observable<any> {
      return this.http
        .get(this.apiService.getApiUrl() + '/api/centro/call/context')
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    centroGetDispositions(): Observable<any> {
      return this.http
        .get(this.apiService.getApiUrl() + '/api/centro/call/dispositions')
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    centroMuteCall(): Observable<any> {
      return this.http
        .post(this.apiService.getApiUrl() + '/api/centro/call/mute', {})
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    centroHoldCall(): Observable<any> {
      return this.http
        .get(this.apiService.getApiUrl() + '/api/centro/call/hold')
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    centroUnholdCall(): Observable<any> {
      return this.http
        .get(this.apiService.getApiUrl() + '/api/centro/call/unhold')
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    centroPauseCall(): Observable<any> {
      return this.http
        .get(this.apiService.getApiUrl() + '/api/centro/agent/pause')
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    centroResumeCall(): Observable<any> {
      return this.http
        .get(this.apiService.getApiUrl() + '/api/centro/agent/resume')
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    centroManualModeStart(): Observable<any> {
      return this.http
        .get(this.apiService.getApiUrl() + '/api/centro/agent/manual-mode/start')
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    centroManualModeStop(): Observable<any> {
      return this.http
        .get(this.apiService.getApiUrl() + '/api/centro/agent/manual-mode/stop')
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    getCentroCampaignAgents(campaignId?: string, options?: { mode?: string }): Observable<any> {
      const params = new URLSearchParams();
      if (campaignId) params.set('campaignId', campaignId);
      if (options?.mode) params.set('mode', options.mode);
      const qs = params.toString() ? `?${params.toString()}` : '';
      return this.http
        .get(this.apiService.getApiUrl() + '/api/centro/campaign-agents' + qs)
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    centroTransferCall(postObj: any): Observable<any> {
      return this.http
        .post(this.apiService.getApiUrl() + '/api/centro/call/transfer', postObj)
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    centroConferenceCall(postObj: { phoneNo: string }): Observable<any> {
      return this.http
        .post(this.apiService.getApiUrl() + '/api/centro/call/conference', postObj)
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    centroMergeCall(): Observable<any> {
      return this.http
        .post(this.apiService.getApiUrl() + '/api/centro/call/merge', {})
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }

    centroUnmergeCall(): Observable<any> {
      return this.http
        .get(this.apiService.getApiUrl() + '/api/centro/call/unmerge')
        .pipe(catchError((e: any) => this.userService.getCheckError(e)));
    }
  
}
